import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DocumentService } from './services/document.service';
import { Router, RouterOutlet } from '@angular/router';
import { FileDragDropDirective } from './directives/file-drag-drop.directive';

import { NavigationService } from './services/navigation.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet, FileDragDropDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  showScreenshotFrame = false;

  constructor(
    private documentService: DocumentService,
    private router: Router,
    private navigation: NavigationService // init service here? correct? i dont know
  ) {}

  async uploadFile(event: FileList | Event) {
    let fileList: FileList | null;

    if (event instanceof Event) {
      fileList = (event.target as HTMLInputElement).files;
    } else {
      fileList = event;
    }
    if (fileList) {
      for (const file of Array.from(fileList)) {
        await this.documentService.uploadDocument(file);
      }
      this.router.navigate(['document', 'inbox']);
    }
  }
}
